import request from '@/utils/request'

export function getVerifyCode(mobile) {
  return request({
    url: '/driver_wy/get_code',
    method: 'post',
    data: { mobile }
  })
}

export function login(mobile, code) {
  return request({
    url: '/driver_wy/login',
    method: 'post',
    data: { mobile, code }
  })
}

export function fetchUserInfo() {
  return request({
    url: '/driver_wy/userInfo',
    method: 'get'
  })
}
